import { render, staticRenderFns } from "./AudioRoom.vue?vue&type=template&id=35432312"
import script from "./AudioRoom.vue?vue&type=script&lang=js"
export * from "./AudioRoom.vue?vue&type=script&lang=js"
import style0 from "./AudioRoom.vue?vue&type=style&index=0&id=35432312&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports